<div class="p-1">
  <table width="100%" style="justify-content: center;">
    <tr *ngIf="!isSmallScreen">
      <td width="25%"> <h5>{{ 'status' | translateWithFallback }}:</h5></td>
      <td width="25%">{{ actualMachineInfo?.CurrentStatus }} <fa-icon [icon]="faCog" animation="spin" *ngIf="MiSvc.statusLoading"></fa-icon></td>
      <td width="25%"><label>{{ 'status-auto-update' | translateWithFallback }}</label></td>
      <td><dx-switch  [(value)]="MiSvc.AutoStatus"></dx-switch></td>
    </tr>
    <tr *ngIf="isSmallScreen">
      <td width="50%"> <h5>{{ 'status' | translateWithFallback }}:</h5></td>
      <td>{{ actualMachineInfo?.CurrentStatus }} <fa-icon [icon]="faCog" animation="spin" *ngIf="MiSvc.statusLoading"></fa-icon></td>
    </tr>
    <tr *ngIf="isSmallScreen">
      <td width="50%"><label>{{ 'status-auto-update' | translateWithFallback }}</label></td>
      <td><dx-switch  [(value)]="MiSvc.AutoStatus"></dx-switch></td>
    </tr>
  </table>

<!-- ########## Remove action start ########## -->
  <dx-button [VisibleForRoles]="['ADMIN','SUPERADMIN']" [hint]="'remove' | translateWithFallback" title="Remove" stylingMode="outlined" [ngClass]="isSmallScreen ? 'w-100 mt-2' : 'm-2'" (click)="openModal(template)">
    <span class="button-content">
      <fa-icon [icon]="faTrash"></fa-icon>
      <span class="pl-2">{{ 'remove' | translateWithFallback }}</span>
    </span>
  </dx-button>

  <ng-template #template>
    <div class="content-block dx-card responsive-paddings pt-35">
      <div class="modal-body text-center">
        <p>{{ 'machine-detail-remove-question' | translateWithFallback }}</p>
        <div class="d-flex gap-5 justify-content-center">
          <dx-button type="danger" stylingMode="outlined" (click)="toTrash()">{{ 'yes' | translateWithFallback }}</dx-button>
          <dx-button type="normal" (click)="decline()">{{ 'no' | translateWithFallback }}</dx-button>
        </div>
      </div>
    </div>
  </ng-template>
<!-- ########## Remove action end ########## -->
<!-- ########## Download action start ########## -->
  <dx-button
    [VisibleForRoles]="['ADMIN','SUPERADMIN']"
    [hint]="'download' | translateWithFallback" title="Download" stylingMode="outlined" [ngClass]="isSmallScreen ? 'w-100 mt-2' : 'm-2'" (click)="download()">
    <span class="button-content">
      <fa-icon *ngIf="!downloadLoading" [icon]="faDownload"></fa-icon>
      <dx-load-indicator
        [(visible)]="downloadLoading"
        [height]="18"
        [width]="18">
      </dx-load-indicator>
      <span class="pl-2">{{ 'download' | translateWithFallback }}</span>
    </span>
  </dx-button>
<!-- ########## Download action end ########## -->
<!-- ########## Copy action start ########## -->
  <dx-button
    [VisibleForRoles]="['ADMIN','SUPERADMIN']"
    [hint]="'copy' | translateWithFallback" stylingMode="outlined" [ngClass]="isSmallScreen ? 'w-100 mt-2' : 'm-2'" (click)="openModal(templateCopy)">
    <span class="button-content">
      <fa-icon [icon]="faCopy"></fa-icon>
      <span class="pl-2">{{ 'copy' | translateWithFallback }}</span>
    </span>
  </dx-button>

  <ng-template #templateCopy>
    <div class="content-block dx-card responsive-paddings pt-35">
      <div class="modal-header align-items-center">
        <h5>{{'copy' | translateWithFallback}}</h5>
        <dx-button class="btn-close close pull-right" aria-label="Close" (click)="decline()">
          <span aria-hidden="true" class="visually-hidden">&times;</span>
        </dx-button>
      </div>
      <div class="modal-body">
        <dx-form [formGroup]="formData">
          <dx-text-box formControlName="MachineName" [placeholder]="'name' | translateWithFallback" [label]="'new-machine-name' | translateWithFallback" [labelMode]="'outside'"></dx-text-box>
        </dx-form>
        <dx-button type="success" class="mt-3" (click)="copy()">
          {{ 'copy' | translateWithFallback }}
        </dx-button>
      </div>
    </div>
  </ng-template>
<!-- ########## Copy action end ########## -->
<!-- ########## Move action start ########## -->
  <dx-button
    [VisibleForRoles]="['ADMIN','SUPERADMIN']"
    [hint]="'move' | translateWithFallback" stylingMode="outlined" [ngClass]="isSmallScreen ? 'w-100 mt-2' : 'm-2'" (click)="openModal(templateMove)">
    <span class="button-content">
      <fa-icon [icon]="faPenToSquare"></fa-icon>
      <span class="pl-2">{{ 'move' | translateWithFallback }}</span>
    </span>
  </dx-button>

  <ng-template #templateMove>
    <div class="content-block dx-card responsive-paddings pt-35">
      <div class="modal-header align-items-center">
        <h5>{{'move' | translateWithFallback}}</h5>
        <dx-button class="btn-close close pull-right" aria-label="Close" (click)="decline()">
          <span aria-hidden="true" class="visually-hidden">&times;</span>
        </dx-button>
      </div>
      <div class="modal-body">
        <dx-form [formGroup]="formData">
          <dx-text-box [label]="'new-machine-name' | translateWithFallback" [labelMode]="'outside'"  formControlName="MachineName"></dx-text-box>
        </dx-form>
        <dx-button type="success" class="mt-3" (click)="move()">
          {{ 'move' | translateWithFallback }}
        </dx-button>
      </div>
    </div>
  </ng-template>
<!-- ########## Move action end ########## -->
<!-- ########## Change owner action start ########## -->
  <dx-button
    [VisibleForRoles]="['SUPERADMIN']"
    [hint]="'change-owner' | translateWithFallback" stylingMode="outlined" [ngClass]="isSmallScreen ? 'w-100 mt-2' : 'm-2'" (click)="openModal(templateChangeOwn)">
    {{ 'change-owner' | translateWithFallback }}
  </dx-button>

  <ng-template #templateChangeOwn>
    <div class="content-block dx-card responsive-paddings pt-35">
      <div class="modal-header align-items-center">
        <h5>{{ 'change-owner' | translateWithFallback }}</h5>
        <dx-button class="btn-close close pull-right" aria-label="Close" (click)="decline()">
          <span aria-hidden="true" class="visually-hidden">&times;</span>
        </dx-button>
      </div>
      <div class="modal-body">
        <dx-form [formGroup]="frmData">
          <dx-select-box [label]="'owner' | translateWithFallback" [labelMode]="'outside'" id="OwnerName" [dataSource]="ownersDs"  displayExpr="Name" formControlName="OwnerName"></dx-select-box>
        </dx-form>
        <dx-button type="success" class="mt-3" (click)="changeOwn()">
          {{ 'submit' | translateWithFallback }}
        </dx-button>
      </div>
    </div>
  </ng-template>
<!-- ########## Change owner action end ########## -->
<!-- ########## Set current machine action start ########## -->
  <dx-button [hint]="'set-as-current' | translateWithFallback" stylingMode="outlined" [ngClass]="isSmallScreen ? 'w-100 mt-2' : 'm-2'" (click)="setCurrentMachine()" *ngIf="MiSvc.CurrentMachineId !== actualMachineInfo?.Id">
    {{ 'set-as-current' | translateWithFallback }}
  </dx-button>
<!-- ########## Set current machine action end ########## -->

</div>

<machine-structure-tree-list [machineName]="actualMachineInfo?.Name ?? undefined" ></machine-structure-tree-list>
